export const formatUnit = (weight, price) => {
  switch (weight) {
    case 0:
      return price + "/st";
    default:
      return price + "/kg";
  }
};

export const getUnit = (weight) => {
  switch (weight) {
    case 0:
      return "/st";
    default:
      return "/kg";
  }
};

export const formatPrice = (price, currency, isBalance) => {
  if (isBalance) {
    price = price / 100;
  }
  switch (currency) {
    case "USA":
      return parseFloat(price).toFixed(2);
    default:
      return "€" + parseFloat(price).toFixed(2).replace(".", ",");
  }
};

export const getPriceOfTypeBasket = (currentItem) => {
  switch (currentItem.product_type) {
    case 1:
      //Stuksartikel
      return currentItem.number * currentItem.salesprice;
    case 2:
    case 3:
      //Gewichtsartikel met een variabel/vast portiegewicht
      return (
        currentItem.number *
        (currentItem.order_weight / 1000) *
        currentItem.salesprice
      );
    default:
      return currentItem.number * currentItem.salesprice;
  }
};

export const calculateBasketTotal = (basketProducts) => {
  if (basketProducts == null) {
    return 0;
  }
  if (basketProducts?.length > 0) {
    basketProducts = basketProducts;
  }
  var prices = basketProducts?.map((i) => getPriceOfTypeBasket(i));
  var totalPrice = prices.reduce((a, b) => a + b, 0);
  return totalPrice;
};

export const getPriceOfTypeOrder = (currentItem) => {
  switch (currentItem.stuk_gewicht) {
    case 1:
      //Stuksartikel
      return currentItem.quantity * currentItem.salesprice;
    case 2:
    case 3:
      //Gewichtsartikel met een variabel/vast portiegewicht
      return (
        currentItem.quantity *
        (currentItem.order_weight / 1000) *
        currentItem.salesprice
      );
    default:
      return currentItem.quantity * currentItem.salesprice;
  }
};

export const calculateOrderTotal = (order) => {
  if (order) {
    var prices = order.map((i) => getPriceOfTypeOrder(i));

    var totalPrice = prices.reduce((a, b) => a + b, 0);

    return formatPrice(totalPrice, "Euro");
  }
};

export default calculateBasketTotal;
